import { requests } from '../../api/services';
import {
    OFFER_EVENT_TRANSFER_OFFERS_URL,
    OFFER_EVENT_TRANSFER_PREVIEW_URL,
    OFFER_EVENT_TRANSFER_URL,
} from '../../utils/Endpoints';
import {
    OfferEventTransferOffer,
    OfferEventTransferPreview,
    OfferEventTransferRequest,
    OfferEventTransferResult,
} from '../../model/offer/OfferEventTransfer';

export const OfferEventTransferService = {
    getSourceOffers: (search: string): Promise<OfferEventTransferOffer[]> =>
        requests.get(OFFER_EVENT_TRANSFER_OFFERS_URL, { search }),
    getTargetOffers: (sourceOfferId: number): Promise<OfferEventTransferOffer[]> =>
        requests.get(`${OFFER_EVENT_TRANSFER_OFFERS_URL}/${sourceOfferId}/targets`),
    preview: (data: OfferEventTransferRequest): Promise<OfferEventTransferPreview> =>
        requests.post(OFFER_EVENT_TRANSFER_PREVIEW_URL, data),
    transfer: (data: OfferEventTransferRequest): Promise<OfferEventTransferResult> =>
        requests.post(OFFER_EVENT_TRANSFER_URL, data),
};
